const STRINGS = {
	passwordStrength: {
		title: gettext('Strength'),
		length: gettext('Password must contain at least 8 characters.'),
		upper: gettext('Password must contain at least 1 uppercase character.'),
		special: gettext('Password must contain at least 1 special character.'),
		number: gettext('Password must contain at least 1 number.'),
	},
};

export default STRINGS;
